import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link } from '@printdeal/ui-library';
import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { dispatchDataLayerEventOnCSClick } from '../../../helpers/dataLayerHelpers/customerServiceDataLayerHelper';
import useSystemPages from '../../../hooks/useSystemPages';

const NAVIGATION_TYPE = 'navigation_customerservice';

type CustomerCareNavigationProps = {
  className?: string;
};

const CustomerCareNavigation = (props: CustomerCareNavigationProps) => {
  const [helpCenterPage] = useSystemPages('helpCenterIndex');

  const handleCustomerServiceLinkClick = () => {
    dispatchDataLayerEventOnCSClick({ navType: NAVIGATION_TYPE });
    addDataLayerEntry(NAVIGATION_TYPE);
  };

  return (
    <Link
      as={GatsbyLink}
      to={helpCenterPage.path}
      onClick={handleCustomerServiceLinkClick}
      variant="secondary"
      iconBefore="customer-service"
      {...props}
    >
      <span className="pd-sr-only lg:pd-not-sr-only">{helpCenterPage.title}</span>
    </Link>
  );
};

export default CustomerCareNavigation;
